import styled from "styled-components";
import { Form, Modal } from "antd";
import { Button2, ResetButton } from "../../../../styles/buttons";

export const ModalWrapper = styled(Modal)`
  max-width: calc(100vw - 32px);

  .ant-modal-content {
    border-radius: 12px;
    overflow: hidden;
  }

  .ant-modal-header {
    padding: 20px 24px 12px;
    border-bottom: none;
  }

  .ant-modal-title {
    font-size: 18px;
    font-weight: 600;
  }

  .ant-modal-body {
    padding-top: 8px;
  }
`;

export const ModalForm = styled(Form)`
  display: flex;
  flex-direction: column;
  min-height: 460px;

  @media (max-width: 768px) {
    min-height: 0;
  }

  .ant-form-item-label > label {
    font-weight: 600;
  }

  .ant-form-item-extra {
    font-size: 12px;
    margin-top: 4px;
  }

  .ant-switch-checked {
    background-color: ${(props) => props.theme.colors.cyanDark};
  }
`;

export const FooterActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
  margin-top: auto;
`;

export const ActiveToggle = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const ToggleLabel = styled.span`
  display: block;
  font-weight: 600;
`;

export const ToggleHint = styled.span`
  display: block;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.45);
`;

export const ActionButtons = styled.div`
  display: flex;
  gap: 10px;

  @media (max-width: 576px) {
    width: 100%;
    flex-direction: column;

    button {
      width: 100%;
    }
  }
`;

export const ConfirmButton = styled(Button2)`
  width: unset;
  margin-top: 0;
  border-radius: 20px;
  padding: 0 24px;
`;

export const CancelButton = styled(ResetButton)`
  width: unset;
  margin-top: 0;
  border-radius: 20px;
  padding: 0 24px;
`;
